<template>
 <b-card v-if="stats.stats.length !== 0" class="stats-block" :title="stats.title">
     <b-list-group>
         <stat-row-display v-for="stat in stats.stats" :key="stat.idStage" :stat="stat"></stat-row-display>
         <stats-order-summary-row :stats="stats.stats"></stats-order-summary-row>
     </b-list-group>
 </b-card>
 <div v-else>
     За выбранный период заказов не найдено
 </div>
</template>

<script>
import StatRowDisplay from './StatRowDisplay'
import StatsOrderSummaryRow from './StatsOrderSummaryRow'

export default {
  name: 'StatsOrderBlock',
  components: {
    StatRowDisplay,
    StatsOrderSummaryRow
  },
  props: {
    stats: Object
  },
  data () {
    return {
      // stats: [
      //   {stageName: 'Новый',
      //     idStage: 1,
      //     timeAvg: {
      //       days: null,
      //       hours: null,
      //       minutes: 3,
      //       months: null,
      //       seconds: 30,
      //       years: null}},
      //   {stageName: 'Приготовление',
      //     idStage: 4,
      //     timeAvg: {
      //       days: null,
      //       hours: null,
      //       minutes: 3,
      //       months: null,
      //       seconds: 30,
      //       years: null}},
      //   {stageName: 'Приготовлен',
      //     idStage: 7,
      //     timeAvg: {
      //       days: null,
      //       hours: null,
      //       minutes: 3,
      //       months: null,
      //       seconds: 30,
      //       years: null}},
      //   {stageName: 'Собран',
      //     idStage: 8,
      //     timeAvg: {
      //       days: null,
      //       hours: null,
      //       minutes: 3,
      //       months: null,
      //       seconds: 30,
      //       years: null} },
      //   {stageName: 'Отправлен',
      //     idStage: 9,
      //     timeAvg: {
      //       days: null,
      //       hours: null,
      //       minutes: 3,
      //       months: null,
      //       seconds: 30,
      //       years: null}}
      // ]
    }
  },
  methods: {
  }
}
</script>

<style scoped>
    .stats-block {
        display: inline-block;
    }
</style>



// WEBPACK FOOTER //
// src/components/StatsOrderBlock.vue